import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICON } from '@core/util/icon';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { select } from '@ngxs/store';
import { TitleInsurancePriceOverrideModalComponent } from '../title-insurance-price-override-modal/title-insurance-price-override-modal.component';
import { ModalService } from '@ui/modal/modal.service';

@Component({
	selector: 'app-title-insurance-price-override',
	templateUrl: './title-insurance-price-override.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TitleInsurancePriceOverrideComponent {
	public ICON = ICON;
	matter_ = select(SelectedMatter.getSelected);
	purchasePrice_ = select(SelectedMatter.purchasePrice);
	purchasePriceOverrideTitleInsurance_ = select(
		SelectedMatter.purchasePriceOverrideTitleInsurance,
	);
	getTitleInsuranceResolvedPurchasePrice_ = select(
		SelectedMatter.getTitleInsuranceResolvedPurchasePrice,
	);

	constructor(private modalService: ModalService) {}

	openModal(): void {
		if (!this.matter_()?.id) return;

		this.modalService.openModal(TitleInsurancePriceOverrideModalComponent, {
			title: 'Edit Purchase Price (Title Insurance Only)',
			data: {
				matterId: this.matter_()?.id,
				price: this.purchasePrice_() || 0,
				priceOverride: this.purchasePriceOverrideTitleInsurance_() || null,
			},
		});
	}
}
